import { render, staticRenderFns } from "./VehicleStatusIcon.vue?vue&type=template&id=a7bc2a7e&scoped=true&"
import script from "./VehicleStatusIcon.vue?vue&type=script&lang=js&"
export * from "./VehicleStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStatusIcon.vue?vue&type=style&index=0&id=a7bc2a7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bc2a7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
